import { TermDto } from '@act/shared/data-transfer-objects';
import InfoIcon from '@mui/icons-material/Info';
import { Alert } from '@mui/material';
import HtmlDisplayer from 'react-components/components/HtmlDisplayer';

export interface ConsentDisplayProps {
  term: TermDto;
}

export const ConsentDisplay = ({ term }: ConsentDisplayProps) => {
  return (
    <div>
      {term?.infoText && (
        <Alert
          severity="info"
          sx={{ backgroundColor: '#CFE6F0', marginBottom: '20px' }}
          icon={<InfoIcon fontSize="inherit" />}
        >
          <HtmlDisplayer innerHtml={term.infoText}></HtmlDisplayer>
        </Alert>
      )}
      <HtmlDisplayer innerHtml={term?.text || ''}></HtmlDisplayer>
    </div>
  );
};
